export default __webpack_public_path__ + "static/media/no-calendar-slots.eb7ee5de.svg";